import { render } from "./Production.vue?vue&type=template&id=43255dca&scoped=true"
import script from "./Production.vue?vue&type=script&lang=js"
export * from "./Production.vue?vue&type=script&lang=js"

import "./Production.vue?vue&type=style&index=0&id=43255dca&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/BEELIA/mi-stock-beelia-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43255dca"]])

export default __exports__